<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex justify-content-between align-items-center flex-1 gap-3">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title title mb-0">
            <img [src]="channel.logoColor" [alt]="channel.friendlyName" />
          </h6>
          <app-page-help
            videoId="-"
            articleId="rngfjwt4fd"
            *ngIf="channel?.name === nameTokens.AirBnBV2API"
          ></app-page-help>
          <app-page-help videoId="-" articleId="-" *ngIf="channel?.name === nameTokens.AgodaAPI"></app-page-help>
          <app-page-help
            videoId="-"
            articleId="2mx4rvnhrd"
            *ngIf="channel?.name === nameTokens.BookingAPI"
          ></app-page-help>
          <app-page-help videoId="-" articleId="-" *ngIf="channel?.name === nameTokens.Trip"></app-page-help>
        </div>
        <div class="flex-fill"></div>
        <button
          *ngIf="connections.length && channel | canAddChannelAccount"
          (click)="onAddAccount()"
          [disabled]="1 | isReadonlyRole"
          type="button"
          matTooltip="Connect another account.  All listings found on connected accounts will appear together under mapped rentals."
          matTooltipPosition="below"
          i18n-matTooltip
          class="btn btn-secondary-info"
        >
          <span class="far fa-plus"></span> <ng-container i18n>Add Account</ng-container>
        </button>

        <button
          *ngIf="connections.length"
          (click)="onDisconnect()"
          [disabled]="1 | isReadonlyRole"
          type="button"
          class="btn btn-secondary-danger"
        >
          <span class="fal fa-ban" aria-hidden="true"></span> <ng-container i18n>Disconnect</ng-container>
        </button>

        <button
          *ngIf="!connections.length"
          (click)="onConnect()"
          [disabled]="1 | isReadonlyRole"
          type="button"
          class="btn btn-secondary-info"
        >
          <span class="fal fa-plug" aria-hidden="true"></span> <ng-container i18n>Connect</ng-container>
        </button>

        <!-- TV4-5830: QA helper, non-production only. Forces the Booking.com connection(s) into the
             disabled / needs-reconnect state so the reconnect banner + email cron can be tested. -->
        <button
          *ngIf="isNonProd && connections.length && channel?.name === nameTokens.BookingAPI"
          (click)="onSimulateBookingError()"
          type="button"
          matTooltip="Testing only (non-production): force this Booking.com connection into the disabled state to trigger the reconnect banner and notification."
          matTooltipPosition="below"
          i18n-matTooltip
          class="btn btn-secondary-warning"
        >
          <span class="fal fa-vial" aria-hidden="true"></span> <ng-container i18n>Simulate Error</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav top-navbar border-bottom bg-white" role="tablist">
      <li [class.active]="currentTab === tabs.MappedRentals">
        <a (click)="currentTab = tabs.MappedRentals"> <ng-container i18n>Mapped Rentals</ng-container> </a>
      </li>
      <li [class.active]="currentTab === tabs.Accounts">
        <a (click)="currentTab = tabs.Accounts"> <ng-container i18n>Accounts</ng-container> </a>
      </li>
    </ul>
    <ul class="nav drawer-right-navbar">
      <li
        [class.active]="currentTab === tabs.Commissions"
        matTooltip="Commissions"
        matTooltipPosition="left"
        i18n-matTooltip
      >
        <a (click)="currentTab = tabs.Commissions">
          <i class="cs-icon cs-icon-dollar-percent text-xxl"></i>
        </a>
      </li>
      <li
        [class.active]="currentTab === tabs.Reviews"
        matTooltip="Reviews"
        matTooltipPosition="left"
        i18n-matTooltip
        *ngIf="isReviewAvailable"
      >
        <a (click)="currentTab = tabs.Reviews">
          <i class="cs-icon cs-icon-thumb-stars"></i>
        </a>
      </li>
      <ng-container *ngIf="channel | isAirBnBV2">
        <li
          [class.active]="currentTab === tabs.ABBOpportunities"
          matTooltip="Opportunities"
          matTooltipPosition="left"
          i18n-matTooltip
        >
          <a (click)="currentTab = tabs.ABBOpportunities">
            <i class="cs-icon cs-icon-dollar-light"></i>
          </a>
        </li>
        <li
          [class.active]="currentTab === tabs.ABBNotifications"
          matTooltip="Notifications"
          matTooltipPosition="left"
          i18n-matTooltip
        >
          <a (click)="currentTab = tabs.ABBNotifications">
            <i class="cs-icon cs-icon-bell"></i>
          </a>
        </li>
      </ng-container>
      <li [class.active]="currentTab === tabs.Formulas" matTooltip="Formulas" matTooltipPosition="left" i18n-matTooltip>
        <a (click)="currentTab = tabs.Formulas">
          <i class="cs-icon cs-icon-calendar-cog"></i>
        </a>
      </li>
      <li
        [class.active]="currentTab === tabs.TwoWaySync"
        *ngIf="channel | isAirBnBV2"
        matTooltip="2-Way Sync"
        matTooltipPosition="left"
        i18n-matTooltip
      >
        <a (click)="currentTab = tabs.TwoWaySync">
          <i class="cs-icon cs-icon-cog-refresh"></i>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <ng-container [ngSwitch]="currentTab">
        <ng-container *ngSwitchCase="tabs.MappedRentals">
          <ng-container *ngIf="channel?.name === nameTokens.Trip">
            <ng-container *ngIf="listingErrors$ | async as listingErrors">
              <div *ngIf="listingErrors.length" class="warning-box" role="alert">
                <div *ngFor="let error of listingErrors">{{ error.message }}</div>
                <div>{{ tripListingRetryText }}</div>
              </div>
            </ng-container>
          </ng-container>
          <div i18n *ngIf="(hasDisabled$ | asyncSchedule | async) && (channel | isAirBnBV2)" class="warning-box">
            We notice you have bad Airbnb connections. Simply click on the Add Account button to reconnect these
            accounts then click on Actions → Refresh Room List. All other settings and rental mappings will remain
            unchanged
          </div>
          <div *ngIf="hasDisconnectedAccounts$ | asyncSchedule | async" class="warning-box">
            <span i18n *ngIf="channel?.name === nameTokens.AgodaAPI; else disconnectedChannelMessage">
              One or more Agoda connections are disabled. Rates and availability are not syncing for their mapped
              rentals. Check the property ID and restore Tokeet access in Agoda. Then use Reconnect on the Accounts tab.
            </span>
            <ng-template #disconnectedChannelMessage
              ><span i18n>
                One or more connections on this channel are disconnected. Rentals mapped to them are not syncing rates
                or availability, which can lead to double bookings. Use the Accounts tab to reconnect.
              </span></ng-template
            >
            <button
              *ngIf="channel?.name === nameTokens.AgodaAPI"
              type="button"
              class="btn btn-secondary-warning ml-2"
              (click)="currentTab = tabs.Accounts"
              i18n
            >
              View Accounts
            </button>
            <span class="text-light ml-2" *ngIf="affectedRentalsCount$ | async as count">
              <ng-container i18n>Rentals affected:</ng-container> <b>{{ count }}</b>
            </span>
          </div>
          <div *ngIf="roomMissingCount$ | async as roomMissingCount" class="warning-box">
            <span i18n>
              {{ roomMissingCount }} mapped rental(s) point to rooms that no longer exist on this channel. These
              mappings cannot sync. Look for the red rows below, then unlink each rental or link it to a current room to
              re-map it.
            </span>
          </div>
          <div *ngIf="unlinkedListingsCount$ | asyncSchedule | async as unlinkedCount" class="warning-box">
            <span i18n>
              One or more listings on this channel were unlinked from AdvanceCM. They are no longer syncing bookings or
              availability, which can lead to double bookings. Find them below and use Link to relink them.
            </span>
            <span class="text-light ml-2">
              <ng-container i18n>Listings affected:</ng-container> <b>{{ unlinkedCount }}</b>
            </span>
          </div>
          <app-channel-mapped-rentals class="container-box d-block" *ngIf="channel" [channel]="channel">
          </app-channel-mapped-rentals>
        </ng-container>
        <ng-container *ngSwitchCase="tabs.Commissions">
          <app-channel-commissions class="d-block" [channel]="channel"></app-channel-commissions>
        </ng-container>
        <ng-container *ngSwitchCase="tabs.ABBOpportunities">
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="d-flex align-items-center gap-2">
              <h6 class="mb-0" i18n>Opportunities</h6>
              <app-page-help articleId="-" videoId="-"></app-page-help>
            </div>
            <div class="flex-fill"></div>
          </div>
          <app-abb-opportunities class="container-box d-block" [channel]="channel"></app-abb-opportunities>
        </ng-container>
        <ng-container *ngSwitchCase="tabs.Reviews">
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="d-flex align-items-center gap-2">
              <h6 class="mb-0" i18n>Reviews</h6>
              <app-page-help articleId="-" videoId="-"></app-page-help>
            </div>
            <div class="flex-fill"></div>
          </div>
          <app-channel-reviews-table class="container-box d-block" [channel]="channel"></app-channel-reviews-table>
        </ng-container>
        <ng-container *ngSwitchCase="tabs.ABBNotifications">
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="d-flex align-items-center gap-2">
              <h6 class="mb-0" i18n>Host Notifications</h6>
              <app-page-help articleId="-" videoId="-"></app-page-help>
            </div>
            <div class="flex-fill"></div>
          </div>
          <app-abb-notifications class="container-box d-block" [channel]="channel" type="host"></app-abb-notifications>
          <div class="d-flex align-items-center gap-3 mb-3 mt-3">
            <div class="d-flex align-items-center gap-2">
              <h6 class="mb-0" i18n>Ground Rule Notifications</h6>
              <app-page-help articleId="-" videoId="-"></app-page-help>
            </div>
            <div class="flex-fill"></div>
          </div>
          <app-abb-notifications
            class="container-box d-block"
            [channel]="channel"
            type="ground-rule"
          ></app-abb-notifications>
        </ng-container>

        <ng-container *ngSwitchCase="tabs.Accounts">
          <app-channel-accounts [channel]="channel"></app-channel-accounts>
        </ng-container>
        <ng-container *ngSwitchCase="tabs.Formulas">
          <ng-template [ngTemplateOutlet]="formulas"></ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="tabs.TwoWaySync">
          <app-abb-sync-settings [channel]="channel"></app-abb-sync-settings>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #formulas>
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0" i18n>Booking Formulas</h6>
      <app-page-help articleId="-" videoId="-"></app-page-help>
    </div>
    <div class="flex-fill"></div>
    <button
      type="button"
      class="btn btn-secondary-danger"
      (click)="table?.onDeleteSelected()"
      [disabled]="table?.selection.isEmpty()"
    >
      <i class="cs-icon cs-icon-trash"></i>&nbsp; <ng-container i18n>Delete</ng-container>
    </button>

    <button type="button" class="btn btn-secondary-info" (click)="table?.onAdd()">
      <i class="far fa-plus"></i>&nbsp; <ng-container i18n>Add</ng-container>
    </button>
  </div>
  <app-booking-formulas-table [channel]="channel" #table></app-booking-formulas-table>
</ng-template>
